var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Colors, Spacing, Icon, Breakpoints } from '@doordash/design-language';
import styled from 'styled-components';
import { WIDER_SPACE } from '../Styles/constants';
// row height * 11 + extra spacing 8px
var TABLE_HEIGHT = Spacing.XxLarge * 11 + Spacing.XxSmall;
var ADMIN_PAGE_SUBPAGE_CONTENT_MIN_HEIGHT = 500;
export var AdminPagePortalWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  padding-top: 80px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  padding-top: 80px;\n"])));
export var AdminPageContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n  padding-top: ", ";\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n  padding-top: ",
    ";\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n  }\n"])), function (p) {
    return !p.shouldRenderMultiPortalDropDown ? '50px' : '';
}, Breakpoints.Mobile);
export var AdminPageSidebarStyle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  background-color: ", ";\n  border-right: ", "px solid ", ";\n"], ["\n  flex-grow: 1;\n  background-color: ", ";\n  border-right: ", "px solid ", ";\n"])), Colors.SystemWhite, Spacing.XxxxSmall, Colors.SystemGrey5);
export var AdminPageContentStyle = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-grow: 3;\n  flex-basis: 60%;\n"], ["\n  flex-grow: 3;\n  flex-basis: 60%;\n"])));
export var AdminPageSubpageContentContainer = styled(AdminPageContentStyle)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  min-height: ", "px;\n  padding: ", "px;\n  position: relative;\n"], ["\n  background-color: ", ";\n  min-height: ", "px;\n  padding: ", "px;\n  position: relative;\n"])), Colors.SystemWhite, ADMIN_PAGE_SUBPAGE_CONTENT_MIN_HEIGHT, WIDER_SPACE);
export var SubpageContentHeaderSecondaryButtonContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: 200px;\n"], ["\n  max-width: 200px;\n"])));
export var StyledDashPassIcon = styled(Icon).attrs(function () { return ({
    type: Icon.Types.LogoDashpassNew,
    size: Icon.Sizes.Medium,
    color: Icon.Colors.TextDashpass,
}); })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
export var tableStyle = {
    tableWrapper: {
        flex: "0 0 " + TABLE_HEIGHT + "px",
    },
    dataCells: {
        verticalAlign: 'middle',
        border: 'none',
    },
    body: {
        border: 'none',
    },
    row: {
        border: 'none',
    },
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
